import { render } from "./CategoryAdd.vue?vue&type=template&id=a0792e86"
import script from "./CategoryAdd.vue?vue&type=script&lang=js"
export * from "./CategoryAdd.vue?vue&type=script&lang=js"

import "./CategoryAdd.vue?vue&type=style&index=0&id=a0792e86&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__